import { render, staticRenderFns } from "./placenamecomment.vue?vue&type=template&id=37b324e8&"
import script from "./placenamecomment.vue?vue&type=script&lang=js&"
export * from "./placenamecomment.vue?vue&type=script&lang=js&"
import style0 from "./placenamecomment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports